'use client';

import React from 'react';

const SkipLink: React.FC = () => {
  const focusNextAfterMain = () => {
    const main = document.querySelector('header');
    if (!main) return;

    const focusables = Array.from(
      document.querySelectorAll<HTMLElement>(
        'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])',
      ),
    );

    const mainContentElement = focusables.find(
      (el) => !main.contains(el) && !!(main.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING),
    );
    mainContentElement?.focus();
  };

  return (
    <button className="skip-link" onClick={() => focusNextAfterMain()}>
      Skip to main content
    </button>
  );
};

export default SkipLink;
